<template>
  <div class="main-footer">
    <template v-if="footer_style === 'original'">
      <div class="custom-footer">
        <img class="logo" src="../assets/images/logo-footer.png" alt="" />
        <img
          src="../assets/images/thin-line.png"
          style="width: 1px; height: 127px"
        />
        <div class="info">
          <div class="slogan">Draft To Real - Let inspiration light up the world, let creativity build brands.</div>
          <div class="phone">Service Hotline:{{ setting.service_phone }}</div>
          <div class="support"> Technical Support: Fujian Hailin Network Technology Co., Ltd.</div>
          <a class="icp" target="_blank" href="https://beian.miit.gov.cn"
            >Copyright © 2025 YICHUANG COMMUNITY
            {{ setting.icp }}</a
          >
        </div>
        <img class="qrcode" src="../assets/images/qrcode.jpg" alt="" />
      </div>
    </template>
    <template v-if="footer_style !== 'original'">
      <div :class="footer_style === 'light' ? 'light-footer' : 'dark-footer'">
        <div class="left-box">
          <div class="left-box-item" @click="$router.push({ name: 'Login' })">
            About Us
          </div>
          <div class="left-box-item" @click="$router.push({name:'BusinessCooperation'})">Business cooperation</div>
          <div class="left-box-item" @click="showChat">Customer service</div>
          <div class="left-box-item" @click="$router.push({name:'UserAppeal'})">Infringement appeal</div>
          <!-- <div class="footer-phone"></div> -->
        </div>
        <div class="right-box">
          <!-- https://beian.miit.gov.cn -->
          <a
            href="/"
            target="_blank"
            class="icp right-box-item"
            >© 2025 YICHUANG COMMUNITY
            {{ setting.icp }}
            </a>
          <!-- <div class="right-box-item right-border">
            技术支持:福建海邻网络科技有限公司
          </div> -->
        </div>
      </div>
    </template>
    <chat ref="chat"></chat>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Footer",
  props: {
    footer_style: {
      type: String,
      default: "light",
    },
  },
  computed: {
    ...mapState(["setting"]),
  },
  methods: {
    showChat() {
				this.$refs["chat"].showChat();
			},
    goBack() {
      this.$router.back();
    },
    go(url) {
      if (url.startsWith("http")) {
        window.open(url, "_blank");
        return;
      }
      this.$router.push({
        path: url,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-footer {
  display: flex;
  .dark-footer {
    background: #1f1f1f;
    width: 100%;
    max-width: 1920px;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #1f1f1f;
    padding: 0 60px;
    color: #ffffff;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    overflow: hidden;
    .left-box {
      display: flex;
      justify-content: start;
      align-items: center;
      height: 100%;
      flex: 1;
      .left-box-item {
        padding-right: 20px;
        white-space:nowrap;
        cursor: pointer;
        &:hover{
          border-bottom:1px solid #ffffff;
        }
      }
      .left-border {
        padding-left: 20px;
        border-left: 1px solid #ffffff;
      }
      .footer-phone {
        background-image: url(../assets/images/icon-phone-footer-white.png);
        background-size: cover;
        background-repeat: no-repeat;
        width: 17px;
        height: 17px;
      }
    }
    .right-box {
      display: flex;
      justify-content: end;
      align-items: center;
      flex: 1;
      height: 100%;
      .right-box-item {
        padding-right: 20px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .right-border {
        padding-left: 20px;
        border-left: 1px solid #ffffff;
      }
      .icp {
        color: #ffffff;
        font-size: 14px;
      }
    }
  }

  .light-footer {
    background: #fff;
    width: 100%;
	max-width:1920px;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #e8e8eb;
    padding: 0 60px;
    color: #808080;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    overflow: hidden;
    .left-box {
      display: flex;
      justify-content: start;
      align-items: center;
      height: 100%;
      flex: 1;
      column-gap:40px;
      .left-box-item {
        // padding-right: 20px;
        cursor: pointer;
        white-space:nowrap;
        &:hover{
          border-bottom:1px solid #1a1a1a;
          color:#1a1a1a;
        }
      }
      .left-border {
        padding-left: 20px;
        border-left: 1px solid #808080;
      }
      .footer-phone {
        background-image: url(../assets/images/icon-phone-footer.png);
        background-size: cover;
        background-repeat: no-repeat;
        width: 17px;
        height: 17px;
      }
    }
    .right-box {
      display: flex;
      justify-content: end;
      align-items: center;
      flex: 1;
      height: 100%;
      .right-box-item {
        padding-right: 20px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .right-border {
        padding-left: 20px;
        border-left: 1px solid #808080;
      }
      .icp {
        color: #808080;
        font-size: 14px;
      }
    }
  }

  .custom-footer {
    height: 210px;
    width: 100%;
    max-width: 1920px;
    padding: 0 293px;
    background: #1f1f1f;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;

    .logo {
      width: 190px;
      height: 60px;
      margin-right: 40px;
    }

    .info {
      width: 930px;
      color: #b3b3b3;
      padding-left: 40px;
      // border-left: 1px solid #ccc;
      .slogan {
        font-size: 20px;
        color: #ffffff;
      }
      .phone {
        margin-bottom: 24px;
        font-size: 16px;
        font-weight: bold;
      }
      .support {
        font-size: 14px;
        margin-bottom: 6px;
      }
      .icp {
        color: #b3b3b3;
        font-size: 14px;
      }
    }
    .qrcode {
      width: 110px;
      height: 110px;
    }
  }
}

@media (max-width: 1279px) {
  .main-footer {
    display: block;
    width: 100%;
    max-width: 1279px;
    // overflow:hidden;
    // overflow-x:hidden;
    .dark-footer {
      width: 100%;
      max-width: 1279px;
      height: 45px;
      padding: 0 60px;
      bottom: 0;
      left: 0;
      right: 0;
      .left-box {
        height: 100%;
        flex: 1;
        .left-box-item {
          padding-right: 20px;
        }
        .left-border {
          padding-left: 20px;
        }
        .footer-phone {
          width: 17px;
          height: 17px;
        }
      }
      .right-box {
        flex: 1;
        height: 100%;
        .right-box-item {
          padding-right: 20px;
        }
        .right-border {
          padding-left: 20px;
        }
        .icp {
          color: #ffffff;
          font-size: 14px;
        }
      }
    }

    .light-footer {
      width: 100%;
      max-width: 1279px;
      height: 45px;
      padding: 0 48px;
      .left-box {
        height: 100%;
        flex: 1;
        .left-box-item {
          padding-right: 16px;
        }
        .left-border {
          padding-left: 16px;
        }
        .footer-phone {
          width: 13.6px;
          height: 13.6px;
        }
      }
      .right-box {
        flex: 1;
        height: 100%;
        .right-box-item {
          padding-right: 16px;
        }
        .right-border {
          padding-left: 16px;
        }
        .icp {
          font-size: 12px;
        }
      }
    }

    .custom-footer {
      height: 210px;
      width: 100%;
      max-width: 1279px;
      padding: 0 134.4px;

      .logo {
        width: 152px;
        height: 48px;
        margin-right: 32px;
      }

      .info {
        width: 930px;
        padding-left: 40px;
        .slogan {
          font-size: 20px;
        }
        .phone {
          margin-bottom: 24px;
          font-size: 16px;
        }
        .support {
          font-size: 14px;
          margin-bottom: 6px;
        }
        .icp {
          font-size: 14px;
        }
      }
      .qrcode {
        width: 110px;
        height: 110px;
      }
    }
  }
}
@media (min-width: 1280px) and (max-width: 1679px) {
  .main-footer {
    width: 100%;
    min-width: 1280px;
    max-width: 1679px;
    .dark-footer {
      width: 100%;
      min-width: 1280px;
      max-width: 1679px;
      height: 40px;
      padding: 0 60px;
      bottom: 0;
      left: 0;
      right: 0;
      .left-box {
        height: 100%;
        flex: 1;
        .left-box-item {
          padding-right: 20px;
        }
        .left-border {
          padding-left: 20px;
        }
        .footer-phone {
          width: 17px;
          height: 17px;
        }
      }
      .right-box {
        flex: 1;
        height: 100%;
        .right-box-item {
          padding-right: 20px;
        }
        .right-border {
          padding-left: 20px;
        }
        .icp {
          font-size: 14px;
        }
      }
    }

    .light-footer {
      flex: 1;
      width: 100%;
      min-width: 1280px;
      max-width: 1679px;
      height: 40px;
      padding: 0 60px;
      bottom: 0;
      left: 0;
      right: 0;
      .left-box {
        height: 100%;
        flex: 1;
        .left-box-item {
          padding-right: 20px;
        }
        .left-border {
          padding-left: 20px;
        }
        .footer-phone {
          width: 17px;
          height: 17px;
        }
      }
      .right-box {
        flex: 1;
        height: 100%;
        .right-box-item {
          padding-right: 20px;
        }
        .right-border {
          padding-left: 20px;
        }
        .icp {
          font-size: 14px;
        }
      }
    }
    .custom-footer {
      height: 189px !important;
      width: 100%;
      min-width: 1280px;
      max-width: 1679px;
      padding: 0 263.7px;

      .logo {
        width: 171px;
        height: 54px;
        margin-right: 36px;
      }

      .info {
        width: 837px;
        padding-left: 36px;
        .slogan {
          font-size: 16px;
        }
        .phone {
          margin-bottom: 21.6px;
          font-size: 14px;
        }
        .support {
          font-size: 12px;
          margin-bottom: 5.4px;
        }
        .icp {
          font-size: 12px;
        }
      }
      .qrcode {
        width: 99px;
        height: 99px;
      }
    }
  }
}
</style>
